import { initializeAuth0 } from './auth0-config';

let auth0Client = null;

export default {
  install(Vue, options = {}) {
    const { store } = options;

    Vue.prototype.$auth0 = {
      async init() {
        auth0Client = await initializeAuth0();

        // Check if user is authenticated
        const isAuthenticated = await auth0Client.isAuthenticated();

        if (isAuthenticated) {
          // Get user info and token
          const user = await auth0Client.getUser();
          const token = await auth0Client.getTokenSilently();

          // Update Vuex store with Auth0 authentication
          if (store) {
            store.commit('setAuth0User', user);
            store.commit('setAuth0Token', token);
            store.commit('setAuthenticated', true);
          }
        }

        return isAuthenticated;
      },

      async login() {
        if (!auth0Client) {
          auth0Client = await initializeAuth0();
        }

        await auth0Client.loginWithRedirect();
      },

      async logout() {
        if (!auth0Client) {
          auth0Client = await initializeAuth0();
        }

        // Clear Vuex store
        if (store) {
          store.commit('setAuth0User', null);
          store.commit('setAuth0Token', null);
          store.commit('setAuthenticated', false);
        }

        await auth0Client.logout({
          logoutParams: {
            returnTo: window.location.origin
          }
        });
      },

      async getToken() {
        if (!auth0Client) {
          auth0Client = await initializeAuth0();
        }

        try {
          return await auth0Client.getTokenSilently();
        } catch (error) {
          console.error('Error getting token:', error);
          throw error;
        }
      },

      async getUser() {
        if (!auth0Client) {
          auth0Client = await initializeAuth0();
        }

        return await auth0Client.getUser();
      },

      async isAuthenticated() {
        if (!auth0Client) {
          auth0Client = await initializeAuth0();
        }

        return await auth0Client.isAuthenticated();
      }
    };
  }
};